<template>
  <div
    class="basket-block panel panel-default sidebar-menu wow fadeInLeft animated mb-2" 
    style="visibility: visible;">
    <div class="panel-heading">
      <h3 class="panel-title">{{ $t('configurator.headings.basket_reorder') }}</h3>
    </div>
    <div class="panel-body text-widget">
      <table class="table table-condensed">
				<thead>
					<tr>
						<th colspan="2">
							<div class="">
								{{ $t("basket.item") }}<span class="basket-price-label">{{ $t("basket.price_in") }}</span>
							</div>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<th colspan="2">{{ $t("summary.articles") }}</th>
					</tr>
					<template v-for="article in printItems" :key="article.id">
						<print-cloud-basket-article :article="article">
						</print-cloud-basket-article>
					</template>
				</tbody>
				<tfoot>
					<tr v-if="activePriceLevel">
						<td>{{ inEnglish ? activePriceLevel.name_en : activePriceLevel.name }} ({{ $filters.formatPercentage(activePriceLevel.percentage) }}%):</td>
						<td class="text-right width--25">{{ $filters.formatMoney(basket.total_price_level) }}</td>
					</tr>
					<tr>
						<th>{{ $t("basket.total") }}:</th>
						<th class="text-right width--25">{{ $filters.formatMoney(basket.total) }}</th>
					</tr>
					<tr v-if="!basket.net_value_only">
						<th>{{ $filters.replaceVatRate($t('basket.total_gross'), vatRate) }}:</th>
						<th class="text-right width--25">{{ $filters.formatMoney(basket.total_gross) }}</th>
					</tr>
				</tfoot>
			</table>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'
import { cloneDeep } from 'lodash'

const store = useMainStore()
// define props
const props = defineProps({
  country: {
    type: Object,
    required: true
  },
  exhibition: {
    type: Object,
    required: true
  },
})
// define computed props
const basket = computed(() => store.print.basket)
const activePriceLevel = computed(() => store.activePriceLevel)
const inEnglish = computed(() => store.activePriceLevel)

const vatRate = computed(() => {
  return basket.value.net_value_only ? 0 : basket.value.default_vat_rate
})

const printItems = computed(() => {
	const items = {}
	basket.value.print_items.forEach((item) => {
		if (!items.hasOwnProperty(item.article_id)) {
			items[item.article_id] = cloneDeep(item)
		} else {
			items[item.article_id].count += item.count
			items[item.article_id].count_after_inclusive += item.count_after_inclusive
			items[item.article_id].inclusive += item.inclusive
		}
	})

	return Object.values(items)
})
</script>